import {Box, Button, Menu, MenuItem} from "@mui/material";
import {connect} from "react-redux";
import {useContext, useEffect, useState} from "react";
import {FirebaseContext} from "../firebase/FirebaseProvider";
import {ScriptVersions} from "../firebase/IFirebaseContext";

interface IProps {
    onSelectVersion: (script: string) => void
    project: string
    state: string
}
function ScriptVersion({onSelectVersion, project, state}: IProps) {
    const [anchor, setAnchor] = useState<HTMLElement>();
    const [open, setOpen] = useState(false);
    const [userNames, setUserNames] = useState<{[user: string]: string}>({});
    const [versions, setVersions] = useState<ScriptVersions>({});
    const {getScriptVersions, getUser} = useContext(FirebaseContext);
    const handleVersionsClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchor(event.currentTarget);
        setOpen(!open);
    };
    const handleVersionsClose = () => setOpen(false);
    const handleVersionClick = (event: React.MouseEvent<HTMLElement>) => {
        const version = event.currentTarget.dataset["version"];

        if (version) {
            onSelectVersion(versions[version].script);
        }
        setOpen(false);
    }

    useEffect(() => {
        getScriptVersions(project, state).then(setVersions);
    }, [getScriptVersions, project, state]);
    useEffect(() => {
        const userKeys = Object.values(versions)
            .map(version => version.user)
            .filter((userKey, index, userKeys) => userKeys.indexOf(userKey) === index)

        userKeys.forEach(userKey => getUser(userKey).then(user => setUserNames(userNames => ({
            ...userNames,
            [userKey]: user.name
        }))));
    }, [getUser, setUserNames, versions]);
    return (
        <Box>
            <Button onClick={handleVersionsClick}>Versions</Button>
            <Menu onClose={handleVersionsClose} open={open} anchorEl={anchor}>
                {Object.keys(versions).map(version => {
                    const details = versions[version];
                    const date = new Date(details.date);
                    const name = userNames[details.user] || "Unknown";

                    return (
                        <MenuItem key={version} data-version={version} onClick={handleVersionClick}>
                            {`${date.toLocaleDateString()} ${date.toLocaleTimeString()} ${name}`}
                        </MenuItem>
                    );
                })}
            </Menu>
        </Box>
    );
}

const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(ScriptVersion);
